import { TechRadarApi } from '@backstage-community/plugin-tech-radar';
import {
  TechRadarLoaderResponse,
  MovedState,
} from '@backstage-community/plugin-tech-radar-common';
import { RepoLensApi } from './RepoLensClient';
import { getGlobalTechRadarFilters } from '../context/TechRadarFilterContext';

const RING_COLORS: Record<string, string> = {
  adopt: '#388e3c',
  trial: '#1976d2',
  assess: '#f57c00',
  hold: '#d32f2f',
};

export class RepoLensTechRadarApi implements TechRadarApi {
  constructor(private readonly repoLensApi: RepoLensApi) {}

  async load(_id: string | undefined): Promise<TechRadarLoaderResponse> {
    // Get current filters from global state
    const filters = getGlobalTechRadarFilters();
    const techRadarData = await this.repoLensApi.getTechRadar(filters);

    const quadrants = [
      { id: 'languages', name: 'Languages' },
      { id: 'frameworks', name: 'Frameworks' },
      { id: 'tools', name: 'Tools' },
      { id: 'platforms', name: 'Platforms' },
    ];

    const rings = [
      {
        id: 'adopt',
        name: 'Adopt',
        color: RING_COLORS.adopt,
        description: 'Technologies we have high confidence in.',
      },
      {
        id: 'trial',
        name: 'Trial',
        color: RING_COLORS.trial,
        description:
          'Technologies worth pursuing for projects that can handle the risk.',
      },
      {
        id: 'assess',
        name: 'Assess',
        color: RING_COLORS.assess,
        description:
          'Technologies worth exploring with the goal of understanding how it will affect your organization.',
      },
      {
        id: 'hold',
        name: 'Hold',
        color: RING_COLORS.hold,
        description: 'Technologies not recommended for new projects.',
      },
    ];

    const entries: TechRadarLoaderResponse['entries'] = [];

    for (const quadrant of techRadarData.quadrants) {
      for (const item of quadrant.items) {
        entries.push({
          key: `${quadrant.name}-${item.name}`,
          id: item.name,
          quadrant: quadrant.name,
          title: `${item.displayName} (${item.count})`,
          timeline: [
            {
              date: new Date(),
              ringId: item.ring || 'adopt',
              description: `Used by ${item.count} components`,
              moved: MovedState.NoChange,
            },
          ],
          description: `${item.displayName} is used by ${item.count} components in the catalog.`,
        });
      }
    }

    return {
      quadrants,
      rings,
      entries,
    };
  }
}
